import * as components from './components'
import * as hooks from './hooks'
import * as types from './types'

console.log('Settings feature initialized!')

export { components, hooks, types }
